module.exports = __webpack_public_path__ + "media/Instruction_62.c1e88498.mp3";